import "./sentry_instrument";
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'overlayscrollbars/overlayscrollbars.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ErrorBoundary } from "react-error-boundary";
import { BrowserRouter } from 'react-router-dom';
import { SnackbarProvider, useSnackbar } from 'notistack';
import CloseIcon from '@mui/icons-material/Close';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { CookiesProvider } from 'react-cookie';
import { DarkModeState, LocationState, NotificationsUnreadState, ThemeState, UserState, UserOpenServiceOrderWorkHistoryState, ServiceInputInMinutesState } from './Components/UserState';
import { ReservationCartState } from './Components/CheckoutState';
import ErrorPage from './Components/ErrorPage';
import { IconButton } from '@mui/material';

const queryClient = new QueryClient();

const SnackbarCloseButton = ({ snackbarKey }) => {
  const { closeSnackbar } = useSnackbar();

  return (
    <IconButton onClick={() => closeSnackbar(snackbarKey)}>
      <CloseIcon />
    </IconButton>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <ErrorBoundary FallbackComponent={ErrorPage}>
    <BrowserRouter
      future={{
        v7_relativeSplatPath: true,
        v7_startTransition: true,
      }} >
      <CookiesProvider>
        <QueryClientProvider client={queryClient}>
          <UserState>
            <NotificationsUnreadState>
              <UserOpenServiceOrderWorkHistoryState>
                <LocationState>
                  <ReservationCartState>
                    <DarkModeState>
                      <ServiceInputInMinutesState>
                        <ThemeState>
                          <SnackbarProvider maxSnack={3} action={snackbarKey => <SnackbarCloseButton snackbarKey={snackbarKey} />}>
                            <App />
                          </SnackbarProvider>
                        </ThemeState>
                      </ServiceInputInMinutesState>
                    </DarkModeState>
                  </ReservationCartState>
                </LocationState>
              </UserOpenServiceOrderWorkHistoryState>
            </NotificationsUnreadState>
          </UserState>
        </QueryClientProvider>
      </CookiesProvider>
    </BrowserRouter>
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
